import { render, staticRenderFns } from "./SliderImageLanguages.vue?vue&type=template&id=a832d26a"
import script from "./SliderImageLanguages.vue?vue&type=script&lang=js"
export * from "./SliderImageLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports